import { put, takeEvery } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import { addReduceRistaCardBalance, bulkUploadCardsData, createNewCardData, deleteCardData, exportCardsData, fetchCardDetailsData, fetchModifyCardDetails, saveCardData, saveCreatedCardDetails, savePhoneCountries, sendTemplate } from "../slices/ristaCard";
import { getErrorMessage, pos_errormap_with_label, pos_errormap_with_label_for_rista_card } from "../../helpers/errors-helper";
import { toastError, toastSuccess } from "../../utils/react-toaster";
import { FILE_UPLOADED_SUCCESSFULLY } from "../../data/rista-card-constants";

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string
  code?: string
  email?: string
}

function* createNewCard(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: ENDPOINT.RISTA_CARD.createNewCard,
      data: actions.payload.dataToPost,
    });
    !response?.code && actions?.payload?.callback && actions?.payload?.callback();
    yield put(saveCardData(response));
  } catch (error) {
    console.log(error);
  }
}

function* fetchCardDetails(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: ENDPOINT.RISTA_CARD.fetchCardDetails,
      data: actions?.payload?.dataToPost,
    });
    yield put(saveCreatedCardDetails(response));
    try {
      const phoneCountriesResponse: ResponseGenerator = yield api.request({
        method: "GET",
        url: ENDPOINT.RISTA_CARD.fetchPhoneCountries,
      });
      const phoneCountriesResponseData: any = phoneCountriesResponse;
      const normalizedPhoneCountries = [
        phoneCountriesResponseData
      ].find(Array.isArray) || [];
      yield put(savePhoneCountries(normalizedPhoneCountries));
    } catch (error) {
      console.log(error);
    }
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* deleteCard(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: `${ENDPOINT.RISTA_CARD.deleteCard}/${actions.payload.cardId}/delete`,
    });
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* bulkUploadCardDetails(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: ENDPOINT.RISTA_CARD.bulkUploadCards,
      data: actions?.payload?.dataToPost,
    });
    if(!response?.code && response?.email) {
      toastSuccess(pos_errormap_with_label_for_rista_card[FILE_UPLOADED_SUCCESSFULLY]);
      actions?.payload?.callback && actions?.payload?.callback(response);
    } else if (response?.code && pos_errormap_with_label_for_rista_card[response.code]) {
      toastError(
        getErrorMessage(
          pos_errormap_with_label_for_rista_card,
          response.code,
          response?.email
        )
      );
    }
  } catch (error) {
    console.log(error);
  }
}

function* exportCardDetails(actions: any) { {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: ENDPOINT.RISTA_CARD.exportCards,
    });
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    console.log(error);
  }
 } 
}

function* addReduceCardBalance(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: ENDPOINT.RISTA_CARD.addReduceCardBalance(actions.payload.cardId),
      data: actions?.payload?.dataToPost,
    });
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions?.payload?.callback({ code: "NETWORK_ERROR" });
  }
}

function* fetchModifiedCardDetails(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "GET",
      url: `${ENDPOINT.RISTA_CARD.fetchModifyCardDetails}?ristaCardId=${actions?.payload?.cardId}`,
    });
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* sendTemplateFile(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "GET",
      url: ENDPOINT.RISTA_CARD.sendTemplateFile,
    });
    if(!response?.code) {
      actions?.payload?.callback && actions?.payload?.callback(response);
    } else if (pos_errormap_with_label[response?.code]) {
      toastError(
        getErrorMessage(
          pos_errormap_with_label,
          response?.code,
          actions.payload?.userEmail
        )
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(createNewCardData.type, createNewCard);
  yield takeEvery(fetchCardDetailsData.type, fetchCardDetails);
  yield takeEvery(deleteCardData.type, deleteCard);
  yield takeEvery(bulkUploadCardsData.type, bulkUploadCardDetails);
  yield takeEvery(exportCardsData.type, exportCardDetails);
  yield takeEvery(fetchModifyCardDetails.type, fetchModifiedCardDetails);
  yield takeEvery(sendTemplate.type, sendTemplateFile);
  yield takeEvery(addReduceRistaCardBalance.type, addReduceCardBalance);
}